import * as moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Account, EditableAccount, EditableAccountDTO} from '../model/account.model';
import { PartieDepot } from '../../entities/requete';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountService {
    constructor(private http: HttpClient) {
    }

    get(): Observable<any> {
        return this.http.get<EditableAccount>('/api/account').pipe(map(account => {
                account.birthDate = this.formatDate(account.birthDate);
                return account;
            })
        );
    }

    getRequerant(email: string, firstName: string, lastName: string): Observable<Account> {
        const params = new HttpParams({
            fromObject: {
                'email': email,
                'firstName': firstName,
                'lastName': lastName
            }
        });
        return this.http.get<EditableAccountDTO>('/api/account', {
            params: params,
            responseType: 'json'

        }).pipe(map(account => {
            account.birthDate = this.formatDate(account.birthDate);
            return account;
        }))
    }

    save(account: EditableAccountDTO): Observable<Object> {
        account.birthDate = this.formatDate(account.birthDate);
        return this.http.put('/api/account', account);
    }

    mapAccountToPartieDepot(account: Account): PartieDepot {
        const partieDepot = new PartieDepot();
        partieDepot.userId = account.id;
        partieDepot.email = account.email;
        partieDepot.type = account.type;
        partieDepot.firstName = account.firstName;
        partieDepot.lastName = account.lastName;
        partieDepot.civilite = account.civilite;
        partieDepot.nomEntreprise = account.nomEntreprise;
        partieDepot.sigleEntreprise = account.sigleEntreprise;
        partieDepot.contact = Object.assign({}, account.contact);
        partieDepot.address = Object.assign({}, account.address);
        return partieDepot;
    }

    mapAccoutToEditableAccount(account: EditableAccountDTO): EditableAccount {
        const editableAccount = new EditableAccount();
        editableAccount.id = account.id;
        editableAccount.civilite = account.civilite;
        editableAccount.firstName = account.firstName;
        editableAccount.lastName = account.lastName;
        editableAccount.birthDate = account.birthDate;
        editableAccount.fonctionEntreprise = account.fonctionEntreprise;
        editableAccount.nomEntreprise = account.nomEntreprise;
        editableAccount.sigleEntreprise = account.sigleEntreprise;
        editableAccount.contact = Object.assign({}, account.contact);
        editableAccount.address = Object.assign({}, account.address);
        editableAccount.notification = account.notification;
        editableAccount.credentials.email = account.email;
        editableAccount.credentials.franceConnectSubscription = account.franceConnectSubscription;
        return editableAccount;
    }

    private formatDate(date): Date {
        return date ? moment(date).format('YYYY-MM-DD') : date;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/account.service.ts